import { render, staticRenderFns } from "./icc.vue?vue&type=template&id=2db8ecae&scoped=true"
import script from "./icc.vue?vue&type=script&lang=js"
export * from "./icc.vue?vue&type=script&lang=js"
import style0 from "./icc.vue?vue&type=style&index=0&id=2db8ecae&prod&lang=scss&scoped=true"
import style1 from "./icc.vue?vue&type=style&index=1&id=2db8ecae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db8ecae",
  null
  
)

export default component.exports